import { Page } from '@react-pdf/renderer'
import React, { useEffect } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import  NotificationDashboard from './NotificationDashboard';

const Notification = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'notification'
        });
    }, []);
  return (
    <>
        <PageHeaderLayout headerTitle={'Cudel Notification'}>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>}>
                Back
            </Button>
        </PageHeaderLayout>
        {/* <AbandonedCartList/> */}
        {/* <AddEditNotification/> */}
        <NotificationDashboard/>
    </>
  )
}

export default Notification